import { CheckboxSettings } from './types';

const commonSettings = {
  borderWidth: 1,
  borderStyle: 'solid',
};

const labelCommonSettings = {
  fontFamily: 'secondary',
  fontSize: 1,
  lineHeight: 1,
  fontWeight: 2,
  '&:focus-visible': {
    outlineColor: 'primary.light',
    outlineStyle: 'solid',
    outlineWidth: '2px',
  },
};

export const checkboxSettings: CheckboxSettings = {
  componentVariants: {
    variant: {
      prop: 'variant',
      variants: {
        'checked-disabled': {
          backgroundColor: 'success.light',
          borderColor: 'success.light',
          ...commonSettings,
        },
        'checked-active': {
          backgroundColor: 'success.main',
          borderColor: 'success.main',
          ...commonSettings,
        },
        'unchecked-disabled': {
          backgroundColor: 'white.dark',
          borderColor: 'gray.main',
          ...commonSettings,
        },
        'unchecked-active': {
          backgroundColor: 'white.main',
          borderColor: 'gray.main',
          boxShadow: 'inset 0px 2px 4px rgba(161, 172, 179, 0.25)',
          ...commonSettings,
          '&:hover': {
            backgroundColor: 'success.light',
            borderColor: 'gray.main',
          },
        },
      },
    },
    size: {
      prop: 'size',
      variants: {
        default: {
          borderRadius: 1,
          width: 16,
          height: 16,
          marginRight: 2,
        },
      },
    },
    label: {
      prop: 'status',
      variants: {
        disabled: {
          ...labelCommonSettings,
          color: 'gray.main',
        },
        active: {
          ...labelCommonSettings,
          color: 'primary.extraDark',
        },
      },
    },
  },
};
